export enum AD_TYPE {
    INTERSTITIAL,
    REWARDED,
    BANNER,
    NUM_OF_AD_TYPES
}
